import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const MessageActivityLog = lazy(() =>
  import("@scenes/MessageActivityLog").then((module) => ({
    default: module.MessageActivityLog,
  }))
);

export const activityLogNRO: NavigationRoutingObject = {
  Component: MessageActivityLog,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "settings",
  heading: (t: I18nT<"dashboard-navigation">) => t("activity-log-sidebar-pill-menu-option", "Message Activity Log"),
  pageNameForTracking: () => "Message Activity Log",
  featureLimitationKeys: ["can_only_view_gated_feature"],
  getDeveloperNavigationAllowed: () => true,
  additionalSearchTerms: (t: I18nT<"dashboard-navigation">) => [
    {
      keywords: [t("activity-log-messaging-activity-log", "Messaging Activity Log")],
      description: t("previously-messaging-activity-log", 'Previously "Messaging Activity Log"'),
    },
    {
      keywords: [t("activity-log-developer-console", "Developer Console")],
      description: t("previously-developer-console", 'Previously in "Developer Console"'),
    },
  ],
  additionalSearchableFeatures: () => ({}),
};
